
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { motion } from "framer-motion";
import { FormField, FormItem, FormLabel, FormControl, FormMessage, Form } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { FormValues } from "./types";
import { useTranslation } from "react-i18next";

interface AccountCreationProps {
  form: UseFormReturn<FormValues>;
  createAccount: boolean;
  useGiftCard: boolean;
}

export const AccountCreationSection: React.FC<AccountCreationProps> = ({ 
  form,
  createAccount, 
  useGiftCard
}) => {
  const { t } = useTranslation();
  
  return (
    <Form {...form}>
      <FormField
        control={form.control}
        name="createAccount"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border border-border p-4">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel>{t("auth.createAccount")}</FormLabel>
              <p className="text-xs text-muted-foreground">
                {t("auth.registerSubtitle")}
              </p>
            </div>
          </FormItem>
        )}
      />
      
      {createAccount && !useGiftCard && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
          className="space-y-4"
        >
          <FormField
            control={form.control}
            name="password"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t("auth.password")}</FormLabel>
                <FormControl>
                  <Input type="password" placeholder={t("auth.passwordPlaceholder")} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          
          <FormField
            control={form.control}
            name="confirmPassword"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t("auth.confirmPassword")}</FormLabel>
                <FormControl>
                  <Input type="password" placeholder={t("auth.confirmPasswordPlaceholder")} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </motion.div>
      )}
    </Form>
  );
};
